import React from 'react';
import LegalLayout, { LegalSection } from '../../components/LegalLayout';

export default function MentionsLegalesEN() {
  return (
    <LegalLayout title="Legal notices" lastUpdated="January 1, 2025">
      <div style={{ background: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px' }}>
        <p style={{ color: '#ffc107', fontSize: '13px', margin: 0 }}>
          <strong>Information only:</strong> This is a summary translation provided for information purposes only.
          The French version of these legal notices is the sole legally binding version.
          In case of any discrepancy between the French and English versions, the French version shall prevail.
        </p>
      </div>
      <LegalSection title="1. Publisher">
        <p>This website is published by <strong>SAS Sanctuaire Consulting Services</strong>.</p>
        <ul>
          <li>Registered address: France</li>
          <li>Email: <a href="mailto:contact@mykurso.fr" className="text-[#ff6b6b]">contact@mykurso.fr</a></li>
          <li>Legal form: Simplified joint-stock company (SAS)</li>
          <li>VAT: not applicable (start-up exemption)</li>
        </ul>
      </LegalSection>
      <LegalSection title="2. Editor-in-chief">
        <p>The editor-in-chief of Kurso is the legal representative of SAS Sanctuaire Consulting Services.</p>
      </LegalSection>
      <LegalSection title="3. Hosting">
        <p>This site is hosted by <strong>Emergent Labs</strong> and its cloud infrastructure partners (Vercel, AWS, or equivalent).</p>
      </LegalSection>
      <LegalSection title="4. Contact">
        <p>For any enquiry, please contact us via the <a href="/contact" className="text-[#ff6b6b]">contact form</a> or by email at <a href="mailto:contact@mykurso.fr" className="text-[#ff6b6b]">contact@mykurso.fr</a>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
